import { IconProps } from './types';

export const EditIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16.308 16.308'>
    <path
      d='M12.231,0,10.193,2.039,14.27,6.116l2.039-2.039ZM8.154,4.077,0,12.231v4.077H4.077l8.154-8.154Z'
      fill='#fff'
      {...props}
    />
  </svg>
);
